// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js!../../helpers/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YUDLwB4QPx {
	font-size: 12px;
	color: var(--ds-text-subtlest, --color-medium-grey);
	margin-top: 4px;
}

.XLSmkkgf4r {
	padding: 0;
}

.SrT2H8_Amd {
	display: flex;
	align-items: center;
	padding: 0;
	flex-wrap: wrap;
}

.DJvqZz7nOD {
	display: inline-flex;
	flex-flow: row nowrap;
	align-items: flex-end;
	margin-bottom: 8px;
}

.DJvqZz7nOD:not(.g9bs61o6OI):before {
	content: '•';
	color: var(--ds-text-subtlest, --color-medium-grey);
	padding: 0 5px;
}

.DJvqZz7nOD:first-child:before {
	display: none;
}

.FegPU3uZRD {
	max-width: 275px;
	padding: 16px 24px;
}

.l_Cvj81aU7 {
	cursor: pointer;
}

.IXZu1ULkGo {
	display: inline-flex;
	flex-flow: row nowrap;
	align-items: flex-end;
}

.jYkD9zmMIT {
	padding-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Comment/CommentActions.module.css"],"names":[],"mappings":"AAEA;CACC,eAAe;CACf,mDAAmD;CACnD,eAAe;AAChB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,mDAAmD;CACnD,cAAc;AACf;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB","sourcesContent":["@import '../../helpers/variables.css';\n\n.actions {\n\tfont-size: 12px;\n\tcolor: var(--ds-text-subtlest, --color-medium-grey);\n\tmargin-top: 4px;\n}\n\n.actionsList {\n\tpadding: 0;\n}\n\n.actionsListWithReactions {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0;\n\tflex-wrap: wrap;\n}\n\n.actionItem {\n\tdisplay: inline-flex;\n\tflex-flow: row nowrap;\n\talign-items: flex-end;\n\tmargin-bottom: 8px;\n}\n\n.actionItem:not(.noDot):before {\n\tcontent: '•';\n\tcolor: var(--ds-text-subtlest, --color-medium-grey);\n\tpadding: 0 5px;\n}\n\n.actionItem:first-child:before {\n\tdisplay: none;\n}\n\n.editDisabledDialogWrapper {\n\tmax-width: 275px;\n\tpadding: 16px 24px;\n}\n\n.editDisabledDialogLink {\n\tcursor: pointer;\n}\n\n.actionItemReactions {\n\tdisplay: inline-flex;\n\tflex-flow: row nowrap;\n\talign-items: flex-end;\n}\n\n.reactionsSpacer {\n\tpadding-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export var actions = `YUDLwB4QPx`;
export var actionsList = `XLSmkkgf4r`;
export var actionsListWithReactions = `SrT2H8_Amd`;
export var actionItem = `DJvqZz7nOD`;
export var noDot = `g9bs61o6OI`;
export var editDisabledDialogWrapper = `FegPU3uZRD`;
export var editDisabledDialogLink = `l_Cvj81aU7`;
export var actionItemReactions = `IXZu1ULkGo`;
export var reactionsSpacer = `jYkD9zmMIT`;
export default ___CSS_LOADER_EXPORT___;
